import { Component } from '@angular/core';
import { MetforminComponent } from '@consultation-upsells/metformin/metformin.component';

@Component({
  selector: 'app-metformin-ed',
  imports: [MetforminComponent],
  templateUrl: './metformin-ed.component.html',
})
export class MetforminEdComponent {}
